import React, { useState, useEffect, useCallback } from "react"
import axios from "axios"
import { Typography, Grid, Card, Dialog, DialogTitle, DialogContent, IconButton, Box, Avatar, Paper, Stack, Tooltip, Divider, Toolbar } from "@mui/material"
import { useAuth } from "../../../../context/AuthContext"
import { useAppData } from "../../../../context/AppDataContext"
import { toast } from "react-toastify"
import ReconciliationTable from "../../../../components/Tables/ReconciliationTable"
import CloseIcon from "@mui/icons-material/Close"
import LoadingScreen from "../../../../LoadingScreen"
import dayjs from "dayjs"
import { DatePicker } from "@mui/x-date-pickers"
import ActivationCard from "./ActivationCard"
import { motion, AnimatePresence } from "framer-motion"

import DSRSummaryBoard from "./DSRSummaryBoard"
import Tile from "./Tile"

import DevicesIcon from "@mui/icons-material/Devices"
import TrendingUpIcon from "@mui/icons-material/TrendingUp"
import PaidIcon from "@mui/icons-material/Paid"
import FlashOnIcon from "@mui/icons-material/FlashOn"
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone"
import HeadphonesIcon from "@mui/icons-material/Headphones"
import CableIcon from "@mui/icons-material/Cable"
import PowerIcon from "@mui/icons-material/Power"
import ExtensionIcon from "@mui/icons-material/Extension"
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag"
import CategoryIcon from "@mui/icons-material/Category"
import { Skeleton } from "@mui/material"

import "react-circular-progressbar/dist/styles.css"
import EmployeeCard from "./EmployeeCard"
import EmployeeIncentiveBreakDown from "./EmployeeIncentiveBreakDown"
import { Button1 } from "../../../../components/Buttons/Button1"

const getKpiColor = (label, value) => {
  switch (label) {
    case "Bill Payment":
      return value >= 1000 ? "#52C41A" : "#FAAD14"
    case "Accessory Sales":
      return value >= 500 ? "#1890FF" : "#FF4D4F"
    case "Device Setup":
      return value >= 50 ? "#52C41A" : "#FAAD14"
    default:
      return "#0d1b3d"
  }
}

const EmployeeBreakDownModal = ({ employeeId, clientId, month: propMonth, year: propYear, rows: propRows, total: propTotal, onClose, title, modalInfo, backOffice }) => {
  useEffect(() => {
    setData()
  }, [])

  const setData = async () => {}
  const handleCreateProfile = () => {}
  return (
    <Dialog
      open={modalInfo?.openModal}
      onClose={onClose}
      fullWidth
      maxWidth="xl"
      PaperProps={{
        sx: {
          background: "rgba(255,255,255,0.08)",
          backdropFilter: "blur(16px)",
          borderRadius: 3,
          border: "1px solid rgba(255,255,255,0.15)",
          boxShadow: "0 12px 28px rgba(0,0,0,0.2)",
          overflow: "hidden",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "rgba(84,104,255,0.08)",
          backdropFilter: "blur(12px)",
          borderBottom: "1px solid rgba(84,104,255,0.2)",
          padding: "10px 30px",
        }}
      >
        <Typography
          variant="h5"
          sx={{
            fontWeight: 700,
            color: "#ffffff !important",
            textShadow: "0 2px 6px rgba(0,0,0,0.3)",
            fontSize: "20px !important",
          }}
          className="va-heading-2"
        >
          {modalInfo?.modalTableTitle} df
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "#0d1b3d" }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        {modalInfo.selectedRow && (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: 20 }} transition={{ type: "spring", stiffness: 200, damping: 25 }}>
            <Card
              // sx={{
              //   borderEndStartRadius: "0px",
              //   borderEndEndRadius: "0px",
              //   border: "2px solid #5468ff61 !important",
              //   borderBottom: "0px !important ",
              //   boxShadow: "var(--va-card-4-box-shadow) !important",
              //   background: "#dfe3ff33",
              // }}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 3,
                p: 2,
                mb: 2,
                borderRadius: 2,
                background: "rgba(255,255,255,0.06)",
                backdropFilter: "blur(10px)",
                boxShadow: "0 6px 16px rgba(0,0,0,0.15)",
                border: "1px solid rgba(84,104,255,0.25)",
              }}
            >
              {/* <CardContent disableGutters sx={{ padding: "0px" }}>
                <Box display="flex" alignItems="center" gap={3} padding={2}> */}
              <Avatar alt={modalInfo.selectedRow.name} src={modalInfo.selectedRow.avatarUrl} sx={{ width: 64, height: 64 }} />
              <Box flex={1}>
                {/* <Typography variant="h6">{modalInfo.selectedRow?.name}</Typography> */}
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#f2f0f0 !important" }} className="va-text-2">
                  {modalInfo.selectedRow?.name}
                </Typography>
                <Typography variant="body2" sx={{ color: "#f2f0f0 !important" }} className="va-text-2">
                  Email: <strong>{modalInfo.selectedRow.email}</strong>
                </Typography>
                <Typography variant="body2" sx={{ color: "#f2f0f0 !important" }} className="va-text-2">
                  Phone: <strong>{modalInfo.selectedRow.phone}</strong>
                </Typography>
                <Typography variant="body2" sx={{ color: "#f2f0f0 !important", mt: 1 }} className="va-text-2">
                  For Period:{" "}
                  <strong>
                    {propMonth?.format("MMMM")} {propYear?.format("YYYY")}
                  </strong>
                </Typography>

                {/* <Box
                  mt={2}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "20px",
                  }}
                >
                  <Typography variant="subtitle1" className="va-text-1">
                    Total Incentive
                  </Typography>
                  <Paper
                    elevation={3}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 1,
                      backgroundColor: "#e8f5e9",
                      color: "#2e7d32",
                      padding: "8px 16px",
                      borderRadius: "12px",
                      fontSize: "1.2rem",
                      fontWeight: "bold",
                      width: "fit-content",
                    }}
                  >
                    <span>$</span>
                    <span>{modalInfo.totalIncentive}</span>
                  </Paper>
                </Box> */}
              </Box>

              <Box
                sx={{
                  mt: 2,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                  gap: 1.5,
                }}
              >
                {modalInfo.selectedRow.account_created ? (
                  <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ type: "spring", stiffness: 200, damping: 20 }}>
                    <Paper
                      elevation={3}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        background: "linear-gradient(135deg, #e0f7fa, #80deea)",
                        color: "#006064",
                        fontWeight: 600,
                        display: "inline-block",
                        boxShadow: "0 6px 18px rgba(0,96,100,0.3)",
                        backdropFilter: "blur(8px)",
                      }}
                    >
                      <Typography variant="body2">
                        <strong>Profile Created</strong> (ID: {modalInfo.selectedRow.user_id})
                      </Typography>
                    </Paper>
                  </motion.div>
                ) : (
                  <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ type: "spring", stiffness: 220, damping: 22 }}>
                    <Paper
                      elevation={2}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        background: "rgba(255, 235, 238, 0.1)",
                        color: "#d32f2f",
                        fontWeight: 500,
                        backdropFilter: "blur(6px)",
                        mb: 1,
                        boxShadow: "0 4px 14px rgba(211,47,47,0.25)",
                      }}
                    >
                      <Typography variant="body2">User profile not created yet for this employee</Typography>
                    </Paper>

                    <motion.div whileHover={{ scale: 1.05, boxShadow: "0 8px 24px rgba(84,104,255,0.4)" }} whileTap={{ scale: 0.95 }} transition={{ type: "spring", stiffness: 300, damping: 20 }}>
                      <Button1
                        variant="contained"
                        onClick={handleCreateProfile}
                        disabled={!backOffice}
                        sx={{
                          maxWidth: 200,
                          background: "linear-gradient(135deg, #5468ff, #809fff)",
                          color: "#fff",
                          fontWeight: 700,
                          textTransform: "none",
                          borderRadius: 2,
                          boxShadow: "0 6px 16px rgba(84,104,255,0.3)",
                          "&:hover": {
                            background: "linear-gradient(135deg, #809fff, #5468ff)",
                            boxShadow: "0 8px 20px rgba(84,104,255,0.5)",
                          },
                        }}
                      >
                        Create Profile
                      </Button1>
                    </motion.div>
                  </motion.div>
                )}
              </Box>
              {/* </Box>
               </CardContent> */}
            </Card>
          </motion.div>
        )}
        <EmployeeIncentiveBreakDown
          isDateChanger={false}
          employeeId={employeeId}
          clientId={clientId}
          month={propMonth.month() + 1}
          year={propYear.year()}
          rows={propRows}
          total={propTotal}
          isModal={false}
          fullWidthParent={true}
          isSmall={true}
        />
      </DialogContent>
    </Dialog>
  )
}

export default EmployeeBreakDownModal
